class ct_drawer_navigation extends HTMLElement {
  constructor() {
    super();
    const childButtons = this.querySelectorAll(".ct-dn-menu-hasChildlinks-inner");
    childButtons.forEach((CB) => {
      CB.addEventListener("click", () => {
        if(CB.nextElementSibling.hasAttribute("expanded")) {
          this.closeDrop(CB);
        } else {
          this.openDrop(CB);          
        }
      });
    });
    const grandChildButtons = this.querySelectorAll(".ct-dn-menu-hasGrandChildlinks-inner");
    grandChildButtons.forEach((gCB) => {
      gCB.addEventListener("click", () => {
        if(gCB.nextElementSibling.hasAttribute("expanded")) {
          this.closeGDrop(gCB);
        } else {
          this.openGDrop(gCB);          
        }
      });
    });
    this.fixMenuHeight();
    window.addEventListener("scroll", () => {
      this.fixMenuHeight();
    });
    this.previousElementSibling.addEventListener("click", () => {
      this.toggleDrawer();
    });
    this.querySelector("[closer]").addEventListener("click", () => {
      this.toggleDrawer();
    });
  }
  toggleDrawer() {
    if(this.hasAttribute("visible")) {
      this.removeAttribute("visible");
      this.previousElementSibling.removeAttribute("visible");
      document.body.style.overflow = "auto";
      document.body.style.touchAction = "";
    } else {
      this.setAttribute("visible", "");
      this.previousElementSibling.setAttribute("visible", "");
      document.body.style.overflow = "hidden";
      document.body.style.touchAction = "none";
    }
  }
  fixMenuHeight() {
    const wrapperHeight = this.offsetHeight;
    const titleHeight = this.querySelector(".ct-dn-title").offsetHeight;
    const footerHeight = this.querySelector(".ct-dn-footer").offsetHeight;
    const paddingTop = parseFloat(getComputedStyle(this).paddingTop);
    const paddingBottom = parseFloat(getComputedStyle(this).paddingBottom);
    const menuHeight = (wrapperHeight - titleHeight - footerHeight - paddingBottom - paddingTop);
    this.querySelector(".ct-dn-menu").style.maxHeight = menuHeight + "px";
  }
  openDrop(element) {
    element.setAttribute("expanded", "");
    element.nextElementSibling.setAttribute("expanded", "");
    element.nextElementSibling.style.height = "auto";
    const height = element.nextElementSibling.offsetHeight;
    element.nextElementSibling.style.height = "0";
    setTimeout(() => { element.nextElementSibling.style.height = height + "px"; }, 20);
  }
  closeDrop(element) {
    element.removeAttribute("expanded");
    element.nextElementSibling.removeAttribute("expanded");
    element.nextElementSibling.style.height = "0";
    const grandChilds = element.nextElementSibling.querySelectorAll(".ct-dn-menu-hasGrandChildlinks-wrapper");
    grandChilds.forEach((gc) => {
      gc.style.height = "0";
      gc.removeAttribute("expanded");
    });
  }

  openGDrop(element) {
    const parent = element.closest(".ct-dn-menu-hasChildlinks-wrapper");
    const parHeight = parent.offsetHeight;
    element.setAttribute("expanded", "");
    element.nextElementSibling.setAttribute("expanded", "");
    element.nextElementSibling.style.height = "auto";
    const height = element.nextElementSibling.offsetHeight;
    element.nextElementSibling.style.height = "0";
    setTimeout(() => {
      element.nextElementSibling.style.height = height + "px";
      parent.style.height = (parHeight + height) + "px";
    }, 20);
  }
  closeGDrop(element) {
    const parent = element.closest(".ct-dn-menu-hasChildlinks-wrapper");
    const parHeight = parent.offsetHeight;
    element.nextElementSibling.removeAttribute("expanded");
    element.removeAttribute("expanded");
    const height = element.nextElementSibling.offsetHeight;
    element.nextElementSibling.style.height = "0";
    parent.style.height = (parHeight - height) + "px";
  }
}

customElements.define("ct-drawer-navigation", ct_drawer_navigation);